import React from "react";
//helpers:
import {getImageFromFilesbyKey, SecondsToMinutes} from "../../../../../_metronic/_helpers";

const VideoCard = ({video, selectedItems, handleItemSelected}) => {
    const isSelected = selectedItems.find(v => v.id === video.id);
    return (
        <div
            key={video.id}
            className={`video_card ${isSelected ? "selected" : ""}`}
            onClick={() => {
                if (isSelected) {
                    const removeSelected = selectedItems.filter(v => v.id !== video.id);
                    if (removeSelected.length) handleItemSelected(removeSelected);
                } else {
                    handleItemSelected([...selectedItems, video]);
                }
            }}
        >
            <div className="dark-overlay_simplevideo" />
            <div
                className="container bg_image_cover"
                style={{
                    backgroundImage: `url(${getImageFromFilesbyKey(video.files, video.id, "imgPortrait", video.type_id)})`,
                }}
            >
                <div className="content">
                    <h5 className="title elipsis_3lines">{video.name || video.title}</h5>
                    {video.duration ? <p>{video.duration ? SecondsToMinutes(video.duration) + " mins" : 0}</p> : null}
                </div>
            </div>
        </div>
    );
};

export default VideoCard;
